import { invert } from 'lodash';

export const assetTypes = {
  '3D Rendering': 1,
  'Room Photography': 2,
  '3D Model': 3,
  'Idea Onboarding': 4,
  'Moodboard Onboarding': 5,
  'User Submitted Room Photography': 6,
  'Message Video Attachment': 7,
  'Message Image Attachment': 8,
  'Review Image': 9,
  'Cloned Board Image': 10,
  '2D Image': 11,
  'Floor Plan': 12,
  'Style Quiz Image': 13,
  'Photo Sphere': 14
};

export const THREE_D_RENDERING = 1;
export const ROOM_PHOTOGRAPHY = 2;
export const THREE_D_MODEL = 3;
export const IDEA_ONBOARDING = 4;
export const MOODBOARD_ONBOARDING = 5;
export const USER_SUBMITTED_ROOM_PHOTOGRAPHY = 6;
export const MESSAGE_VIDEO_ATTACHMENT = 7;
export const MESSAGE_IMAGE_ATTACHMENT = 8;
export const TWO_D_RENDERING = 11;
export const FLOOR_PLAN = 12;
export const STYLE_QUIZ_IMAGE = 13;
export const PHOTO_SPHERE = 14;

export const assetTypesById = invert(assetTypes);

export default assetTypes;
